import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Axios from "../../axiosInstance";
import { accountApiEndpoints } from "../../../api";
import { setLoggedInUserDataInLocalStorage } from "../../../config/config";

const initialState = {
  isLoading: false,
  success: null,
  error: null,
  loginOtp: {
    isLoading: false,
    pinId: null,
    phoneNumber: null,
    error: null,
    success: null,
    tokenInfo: null,
  },
};


export const sendToken = createAsyncThunk(
    "sendToken",
    async (payload, { rejectWithValue }) => {
        try {
            console.log("Calling sendToken...")
            const response = await Axios.post(`${accountApiEndpoints.sendToken}`, payload);
            console.log("sendToken response is: ", response.data)

            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const verifyToken = createAsyncThunk(
    "verifyToken",
    async (payload, { rejectWithValue }) => {
        try {
            console.log("Calling verifyToken with payload: ", payload)
            const response = await Axios.post(`${accountApiEndpoints.verifyToken}`, payload);
            console.log("verifyToken response is: ", response.data)

            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const sendLoginOtp = createAsyncThunk(
    "sendLoginOtp",
    async (payload, { rejectWithValue }) => {
        try {
            console.log("Calling sendLoginOtp with CPR: ", payload.CPR);
            const response = await Axios.post(`${accountApiEndpoints.sendLoginOtp}`, payload);
            console.log("sendLoginOtp response is: ", response.data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || { ErrorMessageEn: "Failed to send OTP" });
        }
    }
);

export const verifyLoginOtp = createAsyncThunk(
    "verifyLoginOtp",
    async (payload, { rejectWithValue }) => {
        try {
            console.log("Calling verifyLoginOtp with payload: ", payload);
            const response = await Axios.post(`${accountApiEndpoints.verifyLoginOtp}`, payload);
            console.log("verifyLoginOtp response is: ", response.data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || { ErrorMessageEn: "Failed to verify OTP" });
        }
    }
);

export const accountOtpSlice = createSlice({
  name: "accountOtpSlice",
  initialState,
  reducers: {
    clearAccountOtpError: (state) => {
      state.error = null;
    },
    clearLoginOtpState: (state) => {
      state.loginOtp = initialState.loginOtp;
    },
  },
  extraReducers: (builder) => {
    // Send Token API
    // Every request is loading, not just the first: this used to skip the
    // flag once an earlier code response was stored, so a second send (or
    // any send after another flow's) showed no spinner in its button.
    builder.addCase(sendToken.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(sendToken.fulfilled, (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.error = null;
    });
    builder.addCase(sendToken.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload?.ErrorMessageEn;
      state.success = false;
      console.log("Get quote error: ", action.payload?.ErrorMessageEn )
    });
    // Verify Token API
    // Every request is loading, not just the first: this used to skip the
    // flag once an earlier code response was stored, so a second send (or
    // any send after another flow's) showed no spinner in its button.
    builder.addCase(verifyToken.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(verifyToken.fulfilled, (state, action) => {
      state.isLoading = false;
      state.success = true;
    });
    builder.addCase(verifyToken.rejected, (state, action) => {
      state.isLoading = false;
      state.success = false;
      state.error = action.error?.message;
    });
    // Send Login OTP API
    builder.addCase(sendLoginOtp.pending, (state) => {
      state.loginOtp.isLoading = true;
      state.loginOtp.error = null;
    });
    builder.addCase(sendLoginOtp.fulfilled, (state, action) => {
      state.loginOtp.isLoading = false;
      state.loginOtp.pinId = action.payload?.pinId;
      state.loginOtp.phoneNumber = action.payload?.phoneNumber;
      state.loginOtp.success = true;
      state.loginOtp.error = null;
    });
    builder.addCase(sendLoginOtp.rejected, (state, action) => {
      state.loginOtp.isLoading = false;
      state.loginOtp.error = action.payload?.ErrorMessageEn || "Failed to send OTP";
      state.loginOtp.success = false;
    });
    // Verify Login OTP API
    builder.addCase(verifyLoginOtp.pending, (state) => {
      state.loginOtp.isLoading = true;
      state.loginOtp.error = null;
    });
    builder.addCase(verifyLoginOtp.fulfilled, (state, action) => {
      state.loginOtp.isLoading = false;
      state.loginOtp.success = true;
      state.loginOtp.error = null;
      state.loginOtp.tokenInfo = action.payload;
      setLoggedInUserDataInLocalStorage(action.payload);
    });
    builder.addCase(verifyLoginOtp.rejected, (state, action) => {
      state.loginOtp.isLoading = false;
      state.loginOtp.error = action.payload?.ErrorMessageEn || "Invalid OTP";
      state.loginOtp.success = false;
    });
  },
});

// SELECTORS
export const getTokenOtpLoading = (store) => store?.accountOtp.isLoading;
export const selectLoginOtpState = (store) => store?.accountOtp.loginOtp;
export const selectLoginOtpLoading = (store) => store?.accountOtp.loginOtp.isLoading;
export const selectLoginOtpPhoneNumber = (store) => store?.accountOtp.loginOtp.phoneNumber;
export const selectLoginOtpPinId = (store) => store?.accountOtp.loginOtp.pinId;
export const selectLoginOtpError = (store) => store?.accountOtp.loginOtp.error;

// ACTIONS TO DISPATCH
export const { clearAccountOtpError, clearLoginOtpState } = accountOtpSlice.actions;

export default accountOtpSlice.reducer;
